/**
 * Labstep
 *
 * @module components/Metadata/Action/ClearValue
 * @desc Action to clear metadata value
 */

import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { MetadataType } from 'labstep-web/models/metadata/types';
import type React from 'react';
import type { MetadataActionClearValueProps } from './types';
import { getClearMetadataBody } from './utils';

const actionComponentProps = {
  type: 'icon',
  icon: 'close',
  elementProps: {
    popup: {
      content: 'Clear',
      position: 'right center',
    },
  },
} as ActionComponentProps;

export const MetadataActionClearValue: React.FC<
  MetadataActionClearValueProps
> = ({ metadata, entity }) => {
  if (!metadata.hasValue || metadata.type === MetadataType.file) {
    return null;
  }

  const { entityName, entityId, body } =
    getClearMetadataBody(metadata);

  if (metadata.getIsServingAsDefaultTemplate(entity)) {
    return null;
  }

  return (
    <EntityActionUpdate
      entityName={entityName}
      id={entityId}
      body={body}
      optimistic
      actionComponentProps={actionComponentProps}
    />
  );
};
